export const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);

export function readJWT(jwt){
    if(jwt == null || jwt == undefined){
        return null;
    }

    try{
        return JSON.parse(Buffer.from(jwt.split('.')[1], 'base64'));
    }catch(error){
        console.log("iAMSmart readJWT error: " + error)
    }
    return null;
}

export async function iAMSmartQR(lang){
    var userAgent = navigator.userAgent;
    var url = `${window.location.origin}/iAMSmart/tdepas/auth/prepare-init`;

    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            userAgent: navigator.userAgent,
            redirectURI: `${window.location.origin}/epas-app/personalInfo`,
            lang: lang,
        })
    })
    .then((response) => {
        if(response.ok){
            return response.text();
        }else{
            throw response;
        }
    })
    .then((data) => {
        data = readJWT(data.substring(1, (data.length -1))).data;
        console.log("iAMSmart helper /auth/prepare-init data: ", data);

        var QRLink = data.action;
        if(userAgent.includes("iPhone") && QRLink.includes("PC_Browser")){
            if(userAgent.includes("EdgiOS")){
                QRLink = QRLink.replace("PC_Browser", "iOS_Edge");
            }else if(userAgent.includes("FxiOS")){
                QRLink = QRLink.replace("PC_Browser", "iOS_Firefox");
            }else if(userAgent.includes("CriOS")){
                QRLink = QRLink.replace("PC_Browser", "iOS_Chrome");
            }else if(userAgent.includes("Safari")){
                QRLink = QRLink.replace("PC_Browser", "iOS_Safari");
            }
        }
        window.open(QRLink,"_self");
    }).catch((error) =>{
        console.log("iAMSmart Direct Login v2 error: " + error)
    });

    return false;
}

export async function iAMSmartToken(authCode, isDirectLoginV2){
    if(authCode == null || authCode == undefined || isDirectLoginV2 == null || isDirectLoginV2 == undefined){
        return null;
    }

    try{
        var url = `${window.location.origin}/iAMSmart/tdepas/auth/response`;

        return await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                code: authCode,
                isDirectLoginV2: isDirectLoginV2
            })
        })
        .then((response) => {
            if(response.ok){
                return response.text();
            }else{
                throw response;
            }
        })
        .then((data) => {
            data = readJWT(data.substring(1, (data.length -1))).data;
            console.log("iAMSmart helper /auth/response data: ", data);
            
            return data;
        });
    }catch(error){
        console.log("iAMSmart helper /auth/response error: " + error)
    }
    return null;
}

export async function iAMSmartProfile(accessToken, openID){
    if(accessToken == null || accessToken == undefined || openID == null || openID == undefined){
        return null;
    }

    try{
        var url = `${window.location.origin}/iAMSmart/tdepas/profile/init`;

        return await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                accessToken: accessToken,
                openID: openID,
                eMEFields: ["enName", "emailAddress", "mobileNumber", "postalAddress", "prefix"],
                profileFields: ["enName"],
            })
        })
        .then((response) => {
            if(response.ok){
                return response.text();
            }else{
                throw response;
            }
        })
        .then((data) => {
            data = readJWT(data.substring(1, (data.length -1))).profile;
            console.log("iAMSmart helper /profile/init data: ", data);

            return data;
        });
    }catch(error){
        console.log("iAMSmart helper /profile/init error: " + error);
    }
    return null;
}


export function iAMSmartProfileTransform(profile){
    //transform structure of returned data from iAMSmart helper to ePAS usable data
    var result = {};
    result.UnstructuredName = replaceUndef(profile?.enName?.UnstructuredName);
    result.SubscriberNumber = replaceUndef(profile?.mobileNumber?.SubscriberNumber);
    result.prefix = replaceUndef(profile?.prefix);
    result.emailAddress = replaceUndef(profile?.emailAddress);

    result.EngUnitNo = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.Eng3dAddress?.EngUnit?.UnitNo);
    result.EngFloorNum = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.Eng3dAddress?.EngFloor?.FloorNum);
    result.EngBuildingName = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.BuildingName);
    result.EngEstateName = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngEstate?.EstateName);
    result.EngBlockDescriptor = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngBlock?.BlockDescriptor);
    result.EngBlockNo = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngBlock?.BlockNo);
    result.EngPhaseNo = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngEstate?.EngPhase?.PhaseNo);
    result.EngBuildingNoFrom = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngStreet?.BuildingNoFrom);
    result.EngStreetName = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngStreet?.StreetName);
    result["EngSub-district"] = replaceUndef(profile?.postalAddress?.EngPremisesAddress?.EngDistrict?.["Sub-district"]);

    result.ChiUnitNo = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.Chi3dAddress?.ChiUnit?.UnitNo);
    result.ChiFloorNum = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.Chi3dAddress?.ChiFloor?.FloorNum);
    result.ChiBuildingName = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.BuildingName);
    result.ChiEstateName = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiEstate?.EstateName);
    result.ChiBlockDescriptor = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiBlock?.BlockDescriptor);
    result.ChiBlockNo = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiBlock?.BlockNo);
    result.ChiPhaseNo = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiEstate?.ChiPhase?.PhaseNo);
    result.ChiBuildingNoFrom = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiStreet?.BuildingNoFrom);
    result.ChiStreetName = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiStreet?.StreetName);
    result["ChiSub-district"] = replaceUndef(profile?.postalAddress?.ChiPremisesAddress?.ChiDistrict?.["Sub-district"]);

    return result;
}

function replaceUndef(value){
    if (typeof value === 'undefined')
        value = "";
    return value;
}